// extracted by mini-css-extract-plugin
export default {"wrapper":"Stats_wrapper__PkEir","card":"Stats_card__d9CIa","cardContent":"Stats_cardContent__-1x3T"};